import { createClient } from "@supabase/supabase-js";

// Create a single instance of the Supabase client with explicit persistence settings
export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL || "",
  import.meta.env.VITE_SUPABASE_ANON_KEY || "",
  {
    auth: {
      persistSession: true,
      storageKey: "sb-auth-token",
    },
  }
);
